import styled from "styled-components";

interface IStyledFieldset{
	showFilters: boolean;
}

const StyledFieldset = styled.fieldset<IStyledFieldset>`
    position: relative;
	width: 100%;
	border-radius: 8px;
	border: 1px solid var(--border-color);
	padding: 10px;
	${(props) => props.showFilters ? "display: flex;" : "display: none;"}
`;

export const DivWithMarginBottom = styled.div`
	margin-bottom: 1.5rem;
`;

export const FilterButtons = styled.div`
	position: absolute;
	right: 5px;
	bottom: 5px;
	display: flex;
	z-index: 4;
`;

export default StyledFieldset;
